import { createContext, useContext, useEffect } from 'react';

/*
 * Chwilowe zwinięcie przypiętego menu do paska ikon, gdy strona potrzebuje miejsca
 * (np. otwarty czat AI obok formularza). Nie zmienia zapisanej preferencji przypięcia:
 * po zwolnieniu ostatniej prośby menu wraca do poprzedniego stanu. Poza Layoutem kontekst jest no-op.
 *
 * Layout trzyma licznik próśb (sidebarPinned.ts), więc kilka komponentów może prosić naraz:
 * `true` dodaje prośbę, `false` ją zwalnia. Hook paruje oba wywołania przez cleanup efektu,
 * więc wywołuj kontekst tylko przez niego (niesparowane `false` nie zejdzie poniżej zera, ale
 * zwolni cudzą prośbę).
 */
type RequestCollapse = (active: boolean) => void;

export const SidebarAutoCollapseContext = createContext<RequestCollapse>(() => {});

/** Prosi Layout o zwinięcie menu, dopóki `active` jest true (i do odmontowania). */
export const useSidebarAutoCollapse = (active: boolean): void => {
  const requestCollapse = useContext(SidebarAutoCollapseContext);
  useEffect(() => {
    if (!active) return undefined;
    requestCollapse(true);
    return () => requestCollapse(false);
  }, [active, requestCollapse]);
};
